import { urlHelper } from '@/helpers/apiHelpers/urlHelper';

export const getOutboundWireDetailsPath = (transactionId: string = ':transactionId', id: string = ':id') => {
  return urlHelper(`/transactions/${transactionId}/outbound-wires/${id}/details`);
};
